import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Icon, Header } from 'semantic-ui-react';
import { LogoSpinner } from 'components';
import { StockExposure as StockAction } from 'actions';
import { colors } from 'utils/colors';
import cn from 'classnames';
import { SimpleTable } from '../../../components/SimpleTable';

class Showcase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      togglePct: props.stockExposure.percentToggled,
      directCollapsed: !this.props.isPrinting,
      indirectCollapsed: !this.props.isPrinting,
    };
  }

  handleToggleCollapse = (item) => {
    this.setState((prevState) => ({ [item]: !prevState[item] }));
  };

  handleTogglePct = (event, togglePct) => {
    const { dispatch } = this.props;
    event.stopPropagation(); // Stop event propagation
    this.setState({ togglePct });
    dispatch(StockAction.togglePercent(togglePct));
  };

  parseNum = (num) =>
    num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  round = (num) => (!num ? 0 : Math.round(num * 10000) / 10000);

  render() {
    const { stockExposure, isFamily, isPrinting, accountRegion } = this.props;
    const { data, prevSearch, isFetching } = stockExposure;
    const {
      num_accounts_exposed,
      total_direct_exposures,
      total_indirect_exposures,
      account_exposures,
    } = data || {};
    const { directCollapsed, indirectCollapsed, togglePct, names } = this.state;
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    const exchangeRate = localStorage.getItem('pwpa-exchange-rate') || 1.3;
    const showSecurityContent =
      stockExposure &&
      data &&
      Object.keys(total_direct_exposures || {}).length !== 0 &&
      total_direct_exposures !== null;

    return !prevSearch ? null : isFetching || !showSecurityContent ? (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '13rem',
          opacity: '0.6',
        }}
      >
        <LogoSpinner />
      </div>
    ) : (
      <div>
        <div style={{ marginTop: '1rem' }}>
          <StyledHeader>
            <span style={{ color: `${colors.blue}` }}>{prevSearch}</span>{' '}
            Exposure Details
          </StyledHeader>
          <Note>
            {`Note: All Account values are displayed in ${
              accountRegion === 'CA' ? 'CAD' : 'USD'
            }${
              accountRegion === 'CA'
                ? `. USD/CAD exchange rate used is ${this.round(
                    Number(exchangeRate)
                  )}`
                : '.'
            }`}
          </Note>
        </div>

        <div>
          <CardContainer>
            <InfoCard>
              <div>{prevSearch} accounts for</div>
              <div
                className="inner-statistic"
                style={{ color: `${colors.blue}` }}
              >
                {this.parseNum(
                  (total_indirect_exposures.pct + total_direct_exposures.pct) *
                    100
                ) < 0.005 &&
                (total_indirect_exposures.pct + total_direct_exposures.pct) *
                  100 !==
                  0
                  ? `~ ${this.parseNum(
                      (total_indirect_exposures.pct +
                        total_direct_exposures.pct) *
                        100
                    )}`
                  : `${this.parseNum(
                      (total_indirect_exposures.pct +
                        total_direct_exposures.pct) *
                        100
                    )}`}
                %
              </div>
              <div>of your total holdings</div>
            </InfoCard>
            <InfoCard>
              <div>As of {formattedDate}, you own</div>
              <div
                className="inner-statistic"
                style={{ color: `${colors.darkBlue}` }}
              >
                $
                {accountRegion === 'CA'
                  ? this.parseNum(
                      total_indirect_exposures.cad + total_direct_exposures.cad
                    )
                  : this.parseNum(
                      total_indirect_exposures.usd + total_direct_exposures.usd
                    )}
              </div>
              <div>of {prevSearch}</div>
            </InfoCard>
            {this.props.fromOverview && (
              <InfoCard>
                <div>{prevSearch} is located in</div>
                <div
                  className="inner-statistic"
                  style={{ color: `${colors.red}` }}
                >
                  {num_accounts_exposed}
                </div>
                <div>of your accounts</div>
              </InfoCard>
            )}
          </CardContainer>

          {!isPrinting ? (
            <Selection>
              <span
                className={cn({ active: togglePct })}
                onClick={(event) => this.handleTogglePct(event, true)}
              >
                % Percentage
              </span>
              <span
                className={cn({ active: !togglePct })}
                onClick={(event) => this.handleTogglePct(event, false)}
              >
                $ Value
              </span>
            </Selection>
          ) : (
            <div style={{ height: '50px' }} />
          )}
          <ElementWrapper style={{ marginBottom: '2rem' }}>
            <Header
              size="medium"
              onClick={() => this.handleToggleCollapse('directCollapsed')}
            >
              <TitleBar>
                Accounts Holding {prevSearch} Directly
                {!isPrinting && (
                  <StyledButton icon>
                    <Icon
                      name="chevron down"
                      style={{
                        transform: directCollapsed
                          ? 'rotate(0deg)'
                          : 'rotate(180deg)',
                      }}
                    />
                  </StyledButton>
                )}
              </TitleBar>
            </Header>
            <Bar>
              <div>Total Direct Exposure</div>
              <div className="main-statistic">
                {!togglePct
                  ? `$${
                      accountRegion === 'CA'
                        ? this.parseNum(total_direct_exposures.cad)
                        : this.parseNum(total_direct_exposures.usd)
                    }`
                  : this.parseNum(total_direct_exposures.pct * 100) < 0.005 &&
                    total_direct_exposures.pct * 100 !== 0
                  ? `~ ${this.parseNum(total_direct_exposures.pct * 100)}%`
                  : `${this.parseNum(total_direct_exposures.pct * 100)}%`}
              </div>
            </Bar>
            <OptionWrapper collapsed={directCollapsed}>
              <div
                style={{
                  borderTop: '1px solid #ccc',
                  margin: '1rem 0 0.5rem 0',
                  width: '100%',
                }}
              />
              <SimpleTable collapsed={directCollapsed}>
                <thead>
                  <tr>
                    <th className="left nowrap">Institution</th>
                    <th className="left nowrap">Account Type</th>
                    <th className="left nowrap">{`Exposure (${
                      togglePct ? '%' : '$'
                    })`}</th>
                    {isFamily && <th className="left nowrap">Client</th>}
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {account_exposures.direct.map((account, index) => (
                    <tr key={index}>
                      <td className="left">{account.account_institution}</td>
                      <td className="left">{account.account_name}</td>
                      <td className="left">
                        {!togglePct
                          ? `$${
                              accountRegion === 'CA'
                                ? this.parseNum(account.exposure.cad)
                                : this.parseNum(account.exposure.usd)
                            }`
                          : account.exposure.pct * 100 < 0.005 &&
                            account.exposure.pct * 100 !== 0
                          ? `~ ${this.parseNum(account.exposure.pct * 100)}%`
                          : `${this.parseNum(account.exposure.pct * 100)}%`}
                      </td>
                      {isFamily && <td className="left">{names[0][index]}</td>}
                    </tr>
                  ))}
                </tbody>
              </SimpleTable>
            </OptionWrapper>
          </ElementWrapper>
          <ElementWrapper>
            <Header
              size="medium"
              onClick={() => this.handleToggleCollapse('indirectCollapsed')}
            >
              <TitleBar>
                Accounts Holding {prevSearch} Indirectly
                {!isPrinting && (
                  <StyledButton icon>
                    <Icon
                      name="chevron down"
                      style={{
                        transform: indirectCollapsed
                          ? 'rotate(0deg)'
                          : 'rotate(180deg)',
                      }}
                    />
                  </StyledButton>
                )}
              </TitleBar>
            </Header>
            <Bar>
              <div>
                <div>Total Indirect Exposure</div>
                <AccountDescription>Including fund of funds</AccountDescription>
              </div>
              <div className="main-statistic">
                {!togglePct
                  ? `$${
                      accountRegion === 'CA'
                        ? this.parseNum(total_indirect_exposures.cad)
                        : this.parseNum(total_indirect_exposures.usd)
                    }`
                  : this.parseNum(total_indirect_exposures.pct * 100) < 0.005 &&
                    total_indirect_exposures.pct * 100 !== 0
                  ? `~ ${this.parseNum(total_indirect_exposures.pct * 100)}%`
                  : `${this.parseNum(total_indirect_exposures.pct * 100)}%`}
              </div>
            </Bar>
            <OptionWrapper collapsed={indirectCollapsed}>
              <div
                style={{
                  borderTop: '1px solid #ccc',
                  margin: '1rem 0 0.5rem 0',
                  width: '100%',
                }}
              />
              <SimpleTable>
                <thead>
                  <tr>
                    <th className="left nowrap">Institution</th>
                    <th className="left nowrap">Account Type</th>
                    <th className="left nowrap">Holding</th>
                    <th className="left nowrap">{`Exposure (${
                      togglePct ? '%' : '$'
                    })`}</th>
                    {isFamily && <th className="left nowrap">Client</th>}
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {account_exposures.indirect.map(
                    (account, index) =>
                      account.funds &&
                      account.funds.map((fund) => (
                        <tr key={index}>
                          <td className="left">
                            {account.account_institution}
                          </td>
                          <td className="left">{account.account_name}</td>

                          {account.funds && (
                            <td className="left">
                              {fund.name} ({fund.ticker})
                            </td>
                          )}

                          <td className="left">
                            {!togglePct
                              ? `$${
                                  accountRegion === 'CA'
                                    ? this.parseNum(fund.exposure.cad)
                                    : this.parseNum(fund.exposure.usd)
                                }`
                              : fund.exposure.pct * 100 < 0.005 &&
                                fund.exposure.pct * 100 !== 0
                              ? `~ ${this.parseNum(fund.exposure.pct * 100)}%`
                              : `${this.parseNum(fund.exposure.pct * 100)}%`}
                          </td>
                          {isFamily && (
                            <td className="left">{names[1][index]}</td>
                          )}
                        </tr>
                      ))
                  )}
                </tbody>
              </SimpleTable>
            </OptionWrapper>
          </ElementWrapper>
        </div>
      </div>
    );
  }
}

Showcase.propTypes = {
  stockExposure: PropTypes.object,
  isFamily: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  isPrinting: PropTypes.bool,
  accountRegion: PropTypes.string,
};

Showcase.defaultProps = {
  stockExposure: {},
  isFamily: false,
  isPrinting: false,
  accountRegion: 'CA',
};

export default connect((state) => ({
  stockExposure: state.StockExposure,
}))(Showcase);

const StyledHeader = styled.h2`
  font-size: 1.6rem !important;
  margin-top: 2rem;
`;

const Note = styled.div`
  font-size: 1.1rem;
  font-style: italic;
  color: rgba(0, 0, 0, 0.5);
  margin: 0 0 0rem 0;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 1rem;
  margin-top: 3rem;
`;

const InfoCard = styled.div`
  display: flex;
  padding: 2rem;
  width: fill-available;
  flex-direction: column !important;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  font-size: 1.2rem;
  font-weight: 600;
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  border: 1px solid #ccc;
  border-radius: 8px;
  .inner-statistic {
    font-size: 1.6rem;
    font-weight: 700;
  }
`;

const OptionWrapper = styled.div`
  transition: max-height 0.8s ease-in-out;
  overflow: hidden;
  max-height: ${(props) => (props.collapsed ? '0' : '1000px')};
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

const StyledButton = styled(Button)`
  background-color: transparent !important;
  color: #000 !important;
  svg {
    transition: transform 0.8s ease-in-out;
  }
`;

const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
`;

const AccountDescription = styled.div`
  font-size: 0.9rem;
  text-align: left;
`;

const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  & .main-statistic {
    color: ${colors.blue};
    font-size: 1.2rem;
  }
`;

const Selection = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: left;
  margin: 1rem 0;

  span {
    padding: 0.3rem 0.7rem;
    cursor: pointer;
    font-size: 0.9rem;
    background-color: white;
    border: 1px solid #dcdcdc;
    user-select: none;
    color: black;

    &.active {
      background-color: ${colors.blue};
      border: 1px solid transparent;
      color: white;
    }

    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    &:hover {
      border: 1px solid ${colors.blue};
    }
  }
`;

const ElementWrapper = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 2rem;
  text-align: left;
  width: 100%;

  &.ringchart {
    width: 60%;
    display: flex;
    flex-direction: column;
  }
  .ringchart-container {
    max-height: 400px;
    max-width: 400px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .ringchart-container-parent {
    height: 100%;
    width: 100%;
  }

  .left {
    text-align: left;
  }
  .nowrap {
    white-space: nowrap;
  }
  .subheader {
    font-weight: bold !important;
  }

  .stat {
    font-weight: bold !important;
    color: ${colors.navyBlue} !important;
  }

  .progress-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1rem;
    width: 100%;
  }

  .concentration-cell {
    .progress {
      width: 30%;
    }
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    align-items: center;
    height: 100%;
  }

  .holdings-cell {
    display: flex;
    flex-direction: column;
    text-align: left;

    .ticker {
      font-weight: bold;
      color: ${colors.darkGrey};
    }

    .total {
      font-weight: bold;
      color: ${colors.navyBlue};
    }
  }

  .insight-text {
    margin-top: 2rem;
  }
`;
